import React, { useEffect } from 'react'
import { MixpanelProvider } from 'react-mixpanel-browser'
import _ from 'lodash'
import PropTypes from 'prop-types'
import UIStore from '../../states/globalStore'
import useMixPanelTracking from '../../libs/MixpanelIntegration'

function IntegrationProvider(props) {
  const { children } = props

  const userProfile = UIStore.useState(s => s.userProfile)
  const userState = _.get(userProfile, ['user'])

  // mixPanel config
  const mixPanelToken = _.get(window, ['_env_', 'MX_PANEL_TOKEN'], null)
  const mxPanelConfig = {
    track_pageview: false,
    autotrack: false,
    ignore_dnt: true
    // kept it on purpose for supporting in qure-utils
    // loaded: function onMixPanelLoad(){
    //   console.log('mixPanel is loaded')
    // }
  }

  return (
    <MixpanelProvider token={mixPanelToken} config={mxPanelConfig}>
      <MixpanelUserContext userState={userState}>
        {children}
      </MixpanelUserContext>
    </MixpanelProvider>
  )
}

const MixpanelUserContext = props => {
  const { userState, children } = props
  const mixPanel = useMixPanelTracking()

  useEffect(() => {
    const emailId = _.get(userState, ['email'], null)
    const username = _.get(userState, ['username'], null)

    if (_.isEmpty(emailId)) {
      return null
    }
    mixPanel.identify(emailId)
    mixPanel.set_people({
      $email: emailId,
      $username: username
    })
  }, [userState])

  return children
}

IntegrationProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default IntegrationProvider
